var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgArtistInfoBlue(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1092_22256)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M18 5.35406C18 4.53625 18.4979 3.80083 19.2572 3.49711L21.6286 2.54855C22.2855 2.28581 23 2.76956 23 3.47703V4.14593C23 4.96374 22.5021 5.69915 21.7428 6.00288L20.3143 6.57427C20.1245 6.6502 20 6.83405 20 7.03851V13C20 14.1045 18.6569 15 17 15C15.3431 15 14 14.1045 14 13C14 11.8954 15.3431 11 17 11C17.1276 11 17.2533 11.0053 17.3768 11.0156C17.6981 11.0424 18 10.8048 18 10.4823V5.35406Z",
    fill: "#0864A6"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.00024 12C10.2094 12 12.0002 10.2091 12.0002 7.99997C12.0002 5.79083 10.2094 3.99997 8.00024 3.99997C5.79111 3.99997 4.00024 5.79083 4.00024 7.99997C4.00024 10.2091 5.79111 12 8.00024 12ZM8.00024 9.99997C9.10481 9.99997 10.0002 9.10454 10.0002 7.99997C10.0002 6.8954 9.10481 5.99997 8.00024 5.99997C6.89567 5.99997 6.00024 6.8954 6.00024 7.99997C6.00024 9.10454 6.89567 9.99997 8.00024 9.99997Z",
    fill: "#0864A6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.42685 16.8138C3.5513 17.2951 3.09646 17.8737 2.94895 18.3162C2.77431 18.8401 2.20799 19.1233 1.68404 18.9487C1.1601 18.774 0.87694 18.2077 1.05159 17.6837C1.40408 16.6263 2.29239 15.7049 3.46341 15.0611C4.65089 14.4084 6.195 14 8.00027 14C9.80554 14 11.3496 14.4084 12.5371 15.0611C13.7081 15.7049 14.5965 16.6263 14.949 17.6837C15.1236 18.2077 14.8404 18.774 14.3165 18.9487C13.7926 19.1233 13.2262 18.8401 13.0516 18.3162C12.9041 17.8737 12.4492 17.2951 11.5737 16.8138C10.7146 16.3416 9.50871 16 8.00027 16C6.49183 16 5.28594 16.3416 4.42685 16.8138Z",
    fill: "#0864A6"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1092_22256"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArtistInfoBlue);
export default __webpack_public_path__ + "static/media/ArtistInfoBlue.20cf0deeed6e9507349ab10e578bf314.svg";
export { ForwardRef as ReactComponent };